<template>
    <div id="app">
        <notifications group="foo" />

        <div id="root" class="h-100">
            <router-view />
        </div>

        <!-- Ask for user's consent about Cookies and data usage -->
        <LGPDAlert />
    </div>
</template>

<script>
import LGPDAlert from '@/components/Template/LGPDAlert'

// element ui lang configuration
import el_locale from 'element-ui/lib/locale'
import el_en from 'element-ui/lib/locale/lang/en'
import el_pt_br from 'element-ui/lib/locale/lang/pt-br'

import { mapState, mapActions } from 'vuex'

export default {
    components: {
        LGPDAlert,
    },
    computed: {
        ...mapState(['internationalization']),
    },
    methods: {
        ...mapActions('internationalization', ['changeLanguageCode']),

        setVH() {
            let vh = window.innerHeight * 0.01
            document.documentElement.style.setProperty('--vh', `${vh}px`)
        },

        setupWindowEvents() {
            window.onresize = this.setVH
        },
    },
    mounted() {
        // setting language for element-ui
        el_locale.use(this.$i18n.locale == 'pt_BR' ? el_pt_br : el_en)

        this.setVH()

        this.setupWindowEvents()

        this.$ExternalTrackers.initGAds()
    },
    created() {
        // let language = localStorage.getItem('language')
        let language = this.$route.query.lang

        if (language) {
            this.$i18n.locale = language
            this.$moment.locale(language == 'en_US' ? 'en-au' : 'pt-br')
            this.changeLanguageCode(language)
        }
        this.$i18n.locale = this.internationalization.selectedLanguage
        this.$moment.locale(this.internationalization.selectedLanguage == 'en_US' ? 'en-au' : 'pt-br')
    },
}
</script>

<style lang="scss">
@import '@/scss/bootstrap/bootstrap-custom.scss';

html,
body {
    height: 100% !important;
}
#app {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow-y: hidden !important;
    position: relative;
}

#root {
    overflow-y: auto;
}

.body {
    display: flex;
    height: 100%;
    .content-container {
        height: 100%;
        width: 100%;
        overflow-y: hidden;
    }
    @media (max-width: 767px) {
        flex-direction: column;
    }
}
</style>
